import { render } from "./createdbyMe.vue?vue&type=template&id=f4dc77a4"
import script from "./createdbyMe.vue?vue&type=script&lang=js"
export * from "./createdbyMe.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__